/**
 * "Open this column's settings" as a one-way request (parity card `P-003`).
 *
 * A cell editor is rendered by the registry and is handed no store: that is what keeps a
 * column type a self-contained folder (CLAUDE.md rule 6). But monday's label picker carries an
 * `✎ Edit Labels` row that opens the column's settings dialog, which the **table view** owns.
 *
 * So the request travels as a DOM `CustomEvent` on `window`: the type folder dispatches it,
 * `TableView` listens and opens its dialog. No import crosses in either direction and the
 * editors stay unit-testable without the grid.
 */
export const COLUMN_SETTINGS_EVENT = 'elizmonday:open-column-settings';

export interface ColumnSettingsRequest {
  readonly columnId: string;
}

export function openColumnSettings(columnId: string): void {
  window.dispatchEvent(
    new CustomEvent<ColumnSettingsRequest>(COLUMN_SETTINGS_EVENT, { detail: { columnId } }),
  );
}

/** Subscribes to the request; returns the unsubscribe. */
export function onColumnSettingsRequested(listener: (columnId: string) => void): () => void {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent<ColumnSettingsRequest>).detail;
    if (detail?.columnId) listener(detail.columnId);
  };
  window.addEventListener(COLUMN_SETTINGS_EVENT, handler);
  return () => window.removeEventListener(COLUMN_SETTINGS_EVENT, handler);
}
